<template>
	<div>
		<!-- The shell owns the header and the surface tabs; each routed view
		     supplies its own page padding beneath them. -->
		<div class="container-fluid px-4 pt-4">
			<div class="d-flex justify-content-between align-items-center mb-4">
				<div>
					<h1 class="mb-0">Traps</h1>
					<p class="text-muted mb-0">
						Your district's trap instances, configurations, devices, sample
						labels, and where each stands.
					</p>
				</div>
			</div>

			<!-- Section navigation: every trap-administration surface is reached
			     from here. -->
			<SectionTabs :tabs="tabs" />
		</div>

		<router-view />
	</div>
</template>

<script setup lang="ts">
import SectionTabs from "@/components/common/SectionTabs.vue";

// Root is the trap-administration section shell: it renders the surface tabs and
// the routed view beneath them. The default surface (Instances) is the existing
// trap-instance list/create; the rest are the administration surfaces.
const tabs = [
	{ to: "/_/traps", label: "Instances", icon: "bi-crosshair" },
	{ to: "/_/traps/stations", label: "Stations", icon: "bi-geo-alt" },
	{
		to: "/_/traps/configuration",
		label: "Configuration",
		icon: "bi-sliders",
	},
	{
		to: "/_/traps/sample-labels",
		label: "Sample Labels",
		icon: "bi-tag",
	},
	{ to: "/_/traps/devices", label: "Devices", icon: "bi-cpu" },
	{ to: "/_/traps/status", label: "Status", icon: "bi-activity" },
];
</script>
